"use client";
import { rpc } from "#rpc";
import { useLang } from "@/i18n/client";
import { StoryblokStory } from "@frend-digital/storyblok";
import { useQuery } from "@tanstack/react-query";

const NotFound = () => {
	const language = useLang();
	const { data, error } = useQuery({
		queryKey: ["not-found", language],
		queryFn: async () => {
			const notFound = await rpc.stories.getNotFound(language);

			return notFound;
		},
	});

	const isLoading = !data && !error;

	if (isLoading) {
		return <div style={{ minHeight: "80vh" }} />;
	}

	if (error || !data) {
		return (
			<div style={{ minHeight: "80vh" }}>
				<Fallback />
			</div>
		);
	}

	return (
		<div style={{ minHeight: "80vh" }}>
			<StoryblokStory story={data} preview={true} />
		</div>
	);
};

export default NotFound;

const Fallback = () => {
	return <div>NotFound</div>;
};
